import { Controller } from "stimulus"

export default class extends Controller {
  disconnect() {
    if (this.request) this.request.abort()
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
  }

  revealAppointment(button) {
    if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
    // Wait until the previous panel is collapsed and the new one is visible.
    // An immediate scroll avoids a smooth animation chasing a changing layout.
    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null
      button.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' })
    })
  }

  async toggle(event) {
    const button = event.currentTarget
    const wasOpen = button.getAttribute('aria-expanded') === 'true'
    if (this.request) this.request.abort()
    this.element.querySelectorAll('[data-details-url]').forEach(item => {
      item.setAttribute('aria-expanded', 'false')
      item.querySelector('[data-details-label]').textContent = 'Voir les détails'
      document.getElementById(item.getAttribute('aria-controls')).hidden = true
    })
    this.revealAppointment(button)
    if (wasOpen) return

    const panel = document.getElementById(button.getAttribute('aria-controls'))
    button.setAttribute('aria-expanded', 'true')
    button.querySelector('[data-details-label]').textContent = 'Masquer les détails'
    panel.hidden = false
    if (panel.dataset.loaded === "true") return
    panel.setAttribute('aria-busy', 'true')
    panel.innerHTML = '<p role="status">Chargement des informations…</p>'
    const request = new AbortController()
    this.request = request
    try {
      const response = await fetch(button.dataset.detailsUrl, {
        headers: { Accept: 'text/html' }, credentials: 'same-origin', signal: request.signal
      })
      if (!response.ok || response.redirected) throw new Error('Meeting details unavailable')
      const html = await response.text()
      if (request.signal.aborted) return
      const template = document.createElement('template')
      template.innerHTML = html
      // The full agenda may already contain a modal for this meeting.
      template.content.querySelectorAll('.modal[id]').forEach(modal => {
        const oldId = modal.id
        modal.id = `${panel.id}-${oldId}`
        template.content.querySelectorAll('[data-target], a[href]').forEach(link => {
          if (link.getAttribute('data-target') === `#${oldId}`) link.setAttribute('data-target', `#${modal.id}`)
          if (link.getAttribute('href') === `#${oldId}`) link.setAttribute('href', `#${modal.id}`)
        })
      })
      template.content.querySelectorAll('trix-editor[input]').forEach(editor => {
        const toolbarId = editor.getAttribute('toolbar')
        const toolbar = Array.from(template.content.querySelectorAll('trix-toolbar[id]')).find(item => item.id === toolbarId)
        if (toolbar) {
          toolbar.id = `${panel.id}-${toolbarId}`
          editor.setAttribute('toolbar', toolbar.id)
        }
        if (editor.id) editor.id = `${panel.id}-${editor.id}`
        const inputId = editor.getAttribute('input')
        const input = Array.from(template.content.querySelectorAll('input[id]')).find(field => field.id === inputId)
        if (input) {
          input.id = `${panel.id}-${inputId}`
          editor.setAttribute('input', input.id)
        }
      })
      panel.replaceChildren(template.content)
      panel.dataset.loaded = 'true'
    } catch (error) {
      if (error.name === 'AbortError') return
      panel.innerHTML = '<p role="alert">Impossible de charger ce rendez-vous. Refermez les détails puis réessayez.</p>'
    } finally {
      if (!request.signal.aborted) panel.setAttribute('aria-busy', 'false')
      if (this.request === request) this.request = null
    }
  }
}
